module.exports = "/static/js/68a92fa05b6dca865b6585da76e4d90b.png";